export function confirmDelete() {
  this.setState({isConfirmOpen: true});
}
